import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { HttpApiAdminService } from './http-api.service';

/**
 * Sugerencias de direcciones (autocomplete). Usa el endpoint del backend
 * `POST /geocode/direcciones` (que proxea el autocomplete server-side con la
 * MAPS_KEY del backend), por lo que el front no depende de Google Maps JS.
 */
@Injectable({
  providedIn: 'root',
})
export class PlacePredictionService {
  private http = inject(HttpApiAdminService);

  async getPlacePredictions(input: string): Promise<string[]> {
    if (!input?.trim()) {
      return [];
    }
    const resp = (await firstValueFrom(
      this.http.post(`/geocode/direcciones`, { text: input }),
    )) as { resultados: string[] };
    return resp?.resultados ?? [];
  }
}
